
import React, { useRef } from "react";
import Button from '../Button/Button'
import i18n from "i18next";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom"
import Svg from "../../assets/icons/icons"
import {
    SearchWrapSt,
    CloseIconSt,
    SearchIconSt,
    SearchInputSt,
    TuneIconSt,
    SubmitInputSt,
} from './style';

const Search = ({
    searchBoxIsOpen = "true",
    iconSearch = "close",
    placeholder = i18n.t(`filter.search`),
    handleOpenSearchBoxClick,
    isWrap = true,
    isButtonShow = false,
    size = "400px",
    className,
    tune,
    tuneFrame,
    _click,
    filter,
    searchWord,
    _clearFilter,
    _openFilter,
    _wholeSiteSearch,
}) => {
    const allSearchInput = useRef(null);
    const searchInput = useRef(null);
    const formRef = useRef(null);

    const history = useHistory();

    // поиск в фильтре
    const filterSearchSubmit = (e) => {
        e.preventDefault();
        _click(searchInput.current.value);
    };

    // общий поиск по сайту
    const searchSubmit = (e) => {
        e.preventDefault();
        const word = allSearchInput.current.value;

        if (word) {
            _wholeSiteSearch(word);
            history.push(`/search`);
        }
    };

    // сброс фильтра и поиска
    const resetFilter = (e) => {
        e.preventDefault();

        _clearFilter();
        formRef.current.reset();
    };

    // верстка строки поиска для фильтра
    const contentSearchForFilter =
        <>
            <SearchWrapSt size={size}>
                {searchBoxIsOpen
                    ?
                    (iconSearch === "search")
                        ?
                        // иконка поиска
                        <SearchIconSt
                            onClick={
                                !filter
                                    ? handleOpenSearchBoxClick
                                    : !searchWord
                                        ? (e) => { filterSearchSubmit(e) }
                                        : (e) => { resetFilter(e) }
                            }>
                            {!searchWord && <Svg type="search" />}
                            {searchWord && <Svg type="close" />}
                        </SearchIconSt>
                        :
                        // иконка закрыть поиск
                        <CloseIconSt onClick={handleOpenSearchBoxClick} >
                            <Svg type="close" />
                        </CloseIconSt>
                    :
                    <SearchIconSt onClick={handleOpenSearchBoxClick} >
                        <Svg type="search" />
                    </SearchIconSt>
                }
                {tune && <TuneIconSt onClick={() => _openFilter()}>
                    {tuneFrame && <Svg type="frame" />}
                    <Svg type="tune" />
                </TuneIconSt>}
                <form
                    ref={formRef}
                    onSubmit={(e) => filterSearchSubmit(e)}
                >
                    <SearchInputSt
                        ref={searchInput}
                        type="text"
                        placeholder={placeholder}
                        className={searchBoxIsOpen ? "opened" : ""}
                        name="search-form"
                        id="searchInput"
                    />
                    {!filter && <SubmitInputSt />}
                </form>
            </SearchWrapSt>
            {isButtonShow &&
                <Button
                    label={i18n.t(`filter.to_find`)}
                    size="middle"
                    _click={() => _click(searchInput.current.value)} />
            }
        </>

    // верстка строки поиска в шапке
    const contentSearchForHeader =
        <>
            {searchBoxIsOpen
                ?
                (iconSearch === "search")
                    ?
                    <SearchIconSt onClick={handleOpenSearchBoxClick}>
                        <Svg type="search" />
                    </SearchIconSt>
                    :
                    <CloseIconSt onClick={handleOpenSearchBoxClick}>
                        <Svg type="close" />
                    </CloseIconSt>
                :
                <SearchIconSt className={className} onClick={handleOpenSearchBoxClick}>
                    <Svg type="search" />
                </SearchIconSt>
            }
            <form
                onSubmit={(e) => searchSubmit(e)}
                autoComplete="off">
                <SearchInputSt
                    ref={allSearchInput}
                    type="text"
                    placeholder={placeholder}
                    className={searchBoxIsOpen ? "opened" : ""}
                    name="search-form"
                />
                <SubmitInputSt type="submit" />
            </form>
        </>

    return (
        (isWrap)
            ?
            <>
                {/* верстка строки поиска для фильтра  */}
                {contentSearchForFilter}
            </>
            :
            <>
                {/* верстка строки поиска в шапке */}
                {contentSearchForHeader}
            </>
    )
};

export default withTranslation()(Search);
